import { Link } from "react-router-dom";
import { TIER_ORDER, TIER_META, PLAN_LABEL } from "../lib/tiers";
import { money, money0 } from "../lib/api";

export const TierPlans = ({ stats }) => {
  if (!stats) return null;
  return (
    <section className="max-w-7xl mx-auto px-5 md:px-10 pb-24" data-testid="tier-plans">
      <p className="eyebrow">Six lines · Standard or Premium</p>
      <h2 className="font-serif-lux text-3xl md:text-4xl mt-3 max-w-2xl">Every line has its own trip fund and its own queue.</h2>
      <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {TIER_ORDER.map((t) => {
          const s = stats[t];
          const { short, icon: Icon, blurb } = TIER_META[t];
          return (
            <div key={t} data-testid={`tier-card-${t}`} className={`lux-card p-7 flex flex-col ${t === "international" ? "border-[#38BDF8]/40" : ""}`}>
              <Icon className="w-6 h-6 text-[#38BDF8]" />
              <h3 className="font-serif-lux text-3xl mt-4">{short}</h3>
              <p className="text-sm text-slate-400 mt-2">{blurb}</p>
              <div className="mt-6 space-y-3 flex-1">
                {s.plans.map((p) => (
                  <div key={p} className="flex items-baseline justify-between border-b border-white/5 pb-2 text-sm">
                    <span className="text-slate-300">{PLAN_LABEL[p]}</span>
                    <span className="text-right">
                      <span data-testid={`tier-price-${t}-${p}`} className="font-mono-lux text-[#38BDF8]">{money(s.plan_prices[p].fee)}/mo</span>
                      <span className="block text-[11px] text-slate-500 font-mono-lux">{money0(s.plan_prices[p].trip)} trip</span>
                      <span data-testid={`tier-premium-${t}-${p}`} className="block text-[11px] font-mono-lux text-[#F43F5E]">Premium {money(s.plan_prices[p].premium_fee)} · {money0(s.plan_prices[p].premium_trip)}</span>
                    </span>
                  </div>
                ))}
                {s.plans.includes("family") && (
                  <p className="text-xs text-slate-500">+{money(s.extra_person_fee)}/mo per extra person · +{money0(s.extra_person_trip)} trip budget</p>
                )}
              </div>
              <p className="text-xs text-slate-500 mt-4">{s.active_members} in line · save {s.autopay_discount_pct}% with autopay</p>
              <Link to="/register" data-testid={`tier-join-${t}`} className="btn-ghost text-center mt-5 py-2.5 text-sm">Join {short}</Link>
            </div>
          );
        })}
      </div>
    </section>
  );
};
